import { BentoGrid } from "@/components/ui/bento-grid";
import { Button } from "@/components/ui/button";
import {
  ArrowRight,
  Paintbrush,
  Code,
  Server,
  ShoppingCart,
  Package,
} from "lucide-react";
import {
  Section,
  SectionContainer,
  SectionHeader,
  SectionTitle,
  SectionDescription,
  SectionContent,
} from "@/components/ui/section";

const services = [
  {
    title: "Web Design",
    icon: <Paintbrush />,
    color: "blue",
    descriptions: [
      "Crafting visually stunning and user-centric interfaces.",
      "Focusing on usability and brand identity for a seamless experience.",
    ],
    colSpan: 2,
  },
  {
    title: "Web Development",
    icon: <Code />,
    color: "green",
    descriptions: [
      "Building high-performance websites with modern technologies.",
      "Expertise in React, Next.js, and scalable architecture.",
    ],
    hasPersistentHover: true,
    colSpan: 3,
  },
  {
    title: "Backend Development",
    icon: <Server />,
    color: "pink",
    descriptions: [
      "Developing secure, scalable, and efficient server-side solutions.",
      "Specializing in API development, databases, and cloud integration.",
    ],
    colSpan: 3,
  },
  {
    title: "E-commerce Solutions",
    icon: <ShoppingCart />,
    color: "orange",
    descriptions: [
      "Creating fully optimized online stores with seamless UX.",
      "Shopify, WooCommerce, and custom e-commerce platforms.",
    ],
    colSpan: 2,
  },
  {
    title: "Custom Web Applications",
    icon: <Package />,
    color: "yellow",
    descriptions: [
      "Developing bespoke web applications for complex business needs.",
      "Optimized for performance, scalability, and security.",
    ],
    colSpan: 5,
  },
];

export default function Services() {
  return (
    <Section id="featured-work">
      <SectionContainer>
        <SectionHeader>
          <SectionTitle>Services</SectionTitle>
          <SectionDescription>
            We harness cutting-edge technologies and industry expertise to build
            high-performing digital experiences tailored to your needs.
          </SectionDescription>
          <Button asChild size="lg" className="group">
            <a href="#contact" className="inline-flex items-center gap-2">
              Let's Work Together
              <ArrowRight
                className="-me-2 ms-0 transition-transform group-hover:translate-x-0.5"
                size={16}
                strokeWidth={2}
                aria-hidden="true"
              />
            </a>
          </Button>
        </SectionHeader>
        <SectionContent>
          <BentoGrid items={services} variant="default" columns={5} />
        </SectionContent>
      </SectionContainer>
    </Section>
  );
}
